import React from 'react'

export function Bio() {
  return (
    <div
      className="flex items-center space-x-4 mt-8 mb-8 text-sm"
      style={{
        backgroundColor: '#faf8f8',
        // backgroundImage: "url('/konoha.jpg')",
        // backgroundPosition: 'center', // to center the background image
      }}
    >
      <div className="container mx-auto shadow-md ">
        <div className="flex items-center ">
          <div className="w-24 pl-4 pr-0">
            <a href="https://github.com/reactima" target="_blank" rel="noreferrer">
              <img src="/ilya.jpg" alt="Ilya Elias S" width="96" height="96" />
            </a>
          </div>
          <div className="flex-grow p-4">
            <div className="font-bold text-lg">
              Ilya Elias S{' '}
              <a href="https://github.com/reactima" target="_blank" rel="noreferrer">
                @reactima
              </a>
            </div>
            <div>React/TS/Node/Python/Golang Coder</div>
            <div>🇯🇵 Japan Permanent Resident</div>
            <div className="text-sm text-gray-600">Used to live in 🇺🇦🇺🇸🇸🇬🇭🇰🇬🇪🇳🇱</div>
          </div>
        </div>
        <div className="w-full mt-0 pl-4 pb-4 ">
          <div className="font-semibold pr-2">
            Interested to discuss the above or looking for a partner to work on Data Mining, Recruitment, B2B Lead
            Generation and/or Outbound SaaS related projects?
          </div>
          <div className="mt-2 mb-2 pr-2">Feel free to ping me to exchange ideas or request a consultation!</div>
          <div className="text-sm pr-2">
            <div>+81 80 4756 2323 (WhatsApp, preferred)</div>
            <div>
              <a href="https://api.whatsapp.com/send?phone=818047562323" target="_blank" rel="noreferrer">
                api.whatsapp.com/send?phone=818047562323
              </a>{' '}
            </div>
            <div>
              <a href="https://t.me/reactima" className="text-blue-600 hover:text-blue-800">
                t.me/reactima
              </a>
            </div>

            <div>
              <a href="mailto:1@ilya1.com" className="text-blue-600 hover:text-blue-800">
                1@ilya1.com
              </a>
            </div>

            <div>
              <a href="https://www.linkedin.com/in/reactima/" className="text-blue-600 hover:text-blue-800">
                linkedin.com/in/reactima
              </a>
            </div>

            <div>
              <a href="https://news.ycombinator.com/user?id=adeptima" className="text-blue-600 hover:text-blue-800">
                @adeptima/@reactima on Hacker News
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function BioBody() {
  return (
    <html lang="en" className="min-h-screen">
      <body className="min-h-screen">
        <div className="flex justify-center items-center h-full">
          <div className="bg-white mx-0 p-4 shadow-md w-full md:max-w-[1024px] min-h-[640px] mx-auto notes-content h-full">
            <Bio />
          </div>
        </div>
      </body>
    </html>
  )
}
